import { render, staticRenderFns } from "./imgtool.vue?vue&type=template&id=728bfefa&scoped=true"
import script from "./imgtool.vue?vue&type=script&lang=ts"
export * from "./imgtool.vue?vue&type=script&lang=ts"
import style0 from "./imgtool.vue?vue&type=style&index=0&id=728bfefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728bfefa",
  null
  
)

export default component.exports